module.exports = __webpack_public_path__ + "img/88678.3d0a1f2b.svg";